// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"4032caa7","193":"d55f7268"}[chunkId] + ".chunk.js";
};